import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { Route } from 'react-router-dom';
import { GlReconPerspective } from './entities/glRecon/GlReconPerspective';

const astGpRoutes = [
  <Route path="gp/gl-recon" element={<EntityView perspectiveComponent={GlReconPerspective} />} />,
]

export default astGpRoutes;